var map = {
	"./communication-services.svg": 95744,
	"./consumer-discretionary.svg": 89325,
	"./consumer-staples.svg": 44159,
	"./energy.svg": 88522,
	"./financials.svg": 93442,
	"./government.svg": 58623,
	"./health-care.svg": 64902,
	"./industrials.svg": 7302,
	"./information-technology.svg": 1415,
	"./materials.svg": 66536,
	"./real-estate.svg": 4971,
	"./utilities.svg": 92062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43953;